export const EVENT_TYPES = [
  { key:"CONFIRMADO",     label:"Confirmado",   light:"#2e7d32", dark:"#1b5e20", text:"#fff" },
  { key:"ESTUDIO",        label:"Estudio",      light:"#c2185b", dark:"#880e4f", text:"#fff" },
  { key:"LIVE",           label:"Live",         light:"#512da8", dark:"#311b92", text:"#fff" },
  { key:"MIDIA",          label:"Midia",        light:"#00695c", dark:"#004d40", text:"#fff" },
  { key:"OUTROS",         label:"Outros",       light:"#616161", dark:"#424242", text:"#fff" },
  { key:"PODCAST",        label:"Podcast",      light:"#1565c0", dark:"#0d47a1", text:"#fff" },
  { key:"PROGRAMA DE TV", label:"Prog. de TV",  light:"#283593", dark:"#1a237e", text:"#fff" },
  { key:"RESERVADO",      label:"Reservado",    light:"#c62828", dark:"#b71c1c", text:"#fff" },
  { key:"TRAMITACAO",     label:"Tramitacao",   light:"#9e9d24", dark:"#827717", text:"#fff" },
];

export const DAYS_PT   = ["DOM","SEG","TER","QUA","QUI","SEX","SAB"];
export const MONTHS_PT = ["JANEIRO","FEVEREIRO","MARCO","ABRIL","MAIO","JUNHO","JULHO","AGOSTO","SETEMBRO","OUTUBRO","NOVEMBRO","DEZEMBRO"];

export const LIGHT = {
  bg:"#efefec", surface:"#fff", surfaceAlt:"#f5f4f1", surfaceHov:"#eceae6",
  header:"#1a1a1a", headerText:"#f0f0f0",
  accent:"#1a56db", accentText:"#fff",
  text:"#111", textSub:"#555", textMuted:"#999",
  border:"#ddd9d3", sep:"#e5e3de",
  inputBg:"#fff", inputBorder:"#ccc",
  shadow:"rgba(0,0,0,0.07)", shadowMd:"rgba(0,0,0,0.15)",
  toastBg:"#111", toastText:"#fff",
  todayBg:"rgba(26,86,219,0.05)", weekendColor:"#1a56db",
  notifDot:"#e53935", notifNew:"#fffde7", notifBorder:"#ffe082",
  modalBg:"rgba(0,0,0,0.45)",
  danger:"#d32f2f", dangerText:"#fff",
  mapBtn:"#1a73e8", mapBtnText:"#fff",
  tag:"#f0f0f0", tagText:"#444",
};
export const DARK = {
  bg:"#111", surface:"#1c1c1c", surfaceAlt:"#222", surfaceHov:"#2a2a2a",
  header:"#0a0a0a", headerText:"#eee",
  accent:"#4f8ef7", accentText:"#fff",
  text:"#eee", textSub:"#aaa", textMuted:"#555",
  border:"#2a2a2a", sep:"#1e1e1e",
  inputBg:"#222", inputBorder:"#383838",
  shadow:"rgba(0,0,0,0.4)", shadowMd:"rgba(0,0,0,0.65)",
  toastBg:"#eee", toastText:"#111",
  todayBg:"rgba(79,142,247,0.07)", weekendColor:"#4f8ef7",
  notifDot:"#f44336", notifNew:"#1a1200", notifBorder:"#3d2c00",
  modalBg:"rgba(0,0,0,0.72)",
  danger:"#f44336", dangerText:"#fff",
  mapBtn:"#4f8ef7", mapBtnText:"#fff",
  tag:"#2a2a2a", tagText:"#bbb",
};

export function typeInfo(key) { return EVENT_TYPES.find(t=>t.key===key) || EVENT_TYPES[0]; }
export function typeColors(key, dark) { const t=typeInfo(key); return { bg:t[dark?"dark":"light"], text:t.text }; }
export function getDaysInMonth(y,m) { return new Date(y,m+1,0).getDate(); }
export function fmtDate(s) { if(!s) return ""; const [y,m,d]=s.split("-"); return `${d}/${m}/${y}`; }
export function mapsUrl(ev) {
  if(ev.lat && ev.lng) return `https://www.google.com/maps/dir/?api=1&destination=${ev.lat},${ev.lng}`;
  const q=encodeURIComponent(`${ev.venue}, ${ev.city}, ${ev.state}, Brasil`);
  return `https://www.google.com/maps/search/?api=1&query=${q}`;
}

// Update PWA icons/title dynamically per agenda
export function applyAgendaBranding(agenda) {
  if (!agenda) return;
  document.title = agenda.name || "Agenda de Shows";
  if (agenda.logoUrl) {
    const fullUrl = agenda.logoUrl.startsWith("http")
      ? agenda.logoUrl
      : `${process.env.REACT_APP_API_URL || ""}${agenda.logoUrl}`;
    let link = document.querySelector("link[rel~='icon']");
    if (link) link.href = fullUrl;
    let apple = document.querySelector("link[rel='apple-touch-icon']");
    if (apple) apple.href = fullUrl;
  }
}
